'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleBanner = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleBanner = exports.SimpleBanner = function SimpleBanner(_ref) {
  var type = _ref.type,
      onClose = _ref.onClose,
      message = _ref.message,
      unclosable = _ref.unclosable;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('banner anim anim--slideInDown', (0, _defineProperty3.default)({}, 'banner--' + type, type))
    },
    !unclosable && _react2.default.createElement(
      'span',
      { className: 'banner__close', onClick: onClose },
      'x'
    ),
    (typeof message === 'undefined' ? 'undefined' : (0, _typeof3.default)(message)) === 'object' && message.id && message.defaultMessage ? _react2.default.createElement(_reactIntl.FormattedMessage, message) : message
  );
};

SimpleBanner.propTypes = {
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  onClose: _propTypes2.default.func.isRequired,
  unclosable: _propTypes2.default.bool,
  type: _propTypes2.default.string
};